/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpPrestigeActionResponsePrestigeResult } from './FuelUpPrestigeActionResponsePrestigeResult';
import {
    FuelUpPrestigeActionResponsePrestigeResultFromJSON,
    FuelUpPrestigeActionResponsePrestigeResultFromJSONTyped,
    FuelUpPrestigeActionResponsePrestigeResultToJSON,
    FuelUpPrestigeActionResponsePrestigeResultToJSONTyped,
} from './FuelUpPrestigeActionResponsePrestigeResult';
import type { FuelUpPrestigeTransaction } from './FuelUpPrestigeTransaction';
import {
    FuelUpPrestigeTransactionFromJSON,
    FuelUpPrestigeTransactionFromJSONTyped,
    FuelUpPrestigeTransactionToJSON,
    FuelUpPrestigeTransactionToJSONTyped,
} from './FuelUpPrestigeTransaction';
import type { FuelUpPrestigeResponse } from './FuelUpPrestigeResponse';
import {
    FuelUpPrestigeResponseFromJSON,
    FuelUpPrestigeResponseFromJSONTyped,
    FuelUpPrestigeResponseToJSON,
    FuelUpPrestigeResponseToJSONTyped,
} from './FuelUpPrestigeResponse';

/**
 * 
 * @export
 * @interface FuelUpPrestigeActionResponse
 */
export interface FuelUpPrestigeActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpPrestigeActionResponse
     */
    success: boolean;
    /**
     * 
     * @type {FuelUpPrestigeResponse}
     * @memberof FuelUpPrestigeActionResponse
     */
    prestige: FuelUpPrestigeResponse;
    /**
     * 
     * @type {FuelUpPrestigeTransaction}
     * @memberof FuelUpPrestigeActionResponse
     */
    transaction?: FuelUpPrestigeTransaction;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeActionResponse
     */
    userFuelBalance?: number;
    /**
     * 
     * @type {FuelUpPrestigeActionResponsePrestigeResult}
     * @memberof FuelUpPrestigeActionResponse
     */
    prestigeResult?: FuelUpPrestigeActionResponsePrestigeResult;
}

/**
 * Check if a given object implements the FuelUpPrestigeActionResponse interface.
 */
export function instanceOfFuelUpPrestigeActionResponse(value: object): value is FuelUpPrestigeActionResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('prestige' in value) || value['prestige'] === undefined) return false;
    return true;
}

export function FuelUpPrestigeActionResponseFromJSON(json: any): FuelUpPrestigeActionResponse {
    return FuelUpPrestigeActionResponseFromJSONTyped(json, false);
}

export function FuelUpPrestigeActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpPrestigeActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'prestige': FuelUpPrestigeResponseFromJSON(json['prestige']),
        'transaction': json['transaction'] == null ? undefined : FuelUpPrestigeTransactionFromJSON(json['transaction']),
        'userFuelBalance': json['userFuelBalance'] == null ? undefined : json['userFuelBalance'],
        'prestigeResult': json['prestigeResult'] == null ? undefined : FuelUpPrestigeActionResponsePrestigeResultFromJSON(json['prestigeResult']),
    };
}

export function FuelUpPrestigeActionResponseToJSON(json: any): FuelUpPrestigeActionResponse {
    return FuelUpPrestigeActionResponseToJSONTyped(json, false);
}

export function FuelUpPrestigeActionResponseToJSONTyped(value?: FuelUpPrestigeActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'prestige': FuelUpPrestigeResponseToJSON(value['prestige']),
        'transaction': FuelUpPrestigeTransactionToJSON(value['transaction']),
        'userFuelBalance': value['userFuelBalance'],
        'prestigeResult': FuelUpPrestigeActionResponsePrestigeResultToJSON(value['prestigeResult']),
    };
}

